import React from "react";
import "./WhyChooseUs.css";
import { Container, Row, Col } from "react-bootstrap";

import img1 from "../assets/event-13.jpg";
import img2 from "../assets/mask-2.png";

const WhyChooseUs = () => {
  return (
    <div className="why-choose-us py-5">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="position-relative mb-4 mb-lg-0 slide-in-left">
            <img
              src={img1}
              alt="Event Planner"
              className="img-fluid rounded main-img"
            />
            <div className="info-card shadow-lg p-4 rounded">
              <div className="d-flex align-items-start mb-4">
                <div className="icon-check">
                  <i className="bi bi-check-circle-fill"></i>
                </div>
                <div>
                  <h5 className="mb-1 fw-bold">Experienced Professionals</h5>
                  <p className="mb-0 text-muted">
                    Our team brings years of industry expertise, ensuring every detail is handled with precision, creativity, and professionalism.
                  </p>
                </div>
              </div>
              <hr />
              <div className="d-flex align-items-start mt-4">
                <div className="icon-check">
                  <i className="bi bi-check-circle-fill"></i>
                </div>
                <div>
                  <h5 className="mb-1 fw-bold">Clear And Upfront Costs</h5>
                  <p className="mb-0 text-muted">
                   We believe in transparency—no hidden fees, just honest pricing tailored to your needs and budget from the start.
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} className="slide-in-right">
            <p className="text-uppercase small text-purple mb-2">Why Choose Us</p>
            <h2 className="fw-bold text-dark mb-3">
              Highlighting Reasons To Select Our Services
            </h2>
            <p className="text-muted">
              We’re more than just service providers—we’re your trusted partners in creating memorable experiences. With a client-first mindset, innovative planning, and reliable execution, we deliver excellence at every step to bring your vision to life.
            </p>
            <img src={img2} alt="Event" className="img-fluid rounded mt-4" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default WhyChooseUs;
